import { render } from "./settings.vue?vue&type=template&id=7c771d9e&scoped=true&ts=true"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"

import "./settings.vue?vue&type=style&index=0&id=7c771d9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c771d9e"]])

export default __exports__